import { useState, useEffect } from "react";
import { fetchPage } from "../lib/api";
import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import PageSections from "../components/PageSections";
import EnquiryForm from "../components/EnquiryForm";

export default function Contact() {
  const [page, setPage] = useState(null);
  useEffect(() => { fetchPage("contact").then(setPage).catch(() => {}); }, []);

  return (
    <>
      <Seo title={page?.meta_title} description={page?.meta_description} robots={page?.meta_robots} jsonLd={page?.schema_json} />
      <PageHero
        eyebrow="Contact"
        title={page?.title || "Get in touch"}
        subtitle="Call Akram on 07472 887780 or send a quick message — we reply within one working day."
      />
      <div data-testid="contact-page">
        <PageSections sections={page?.sections || []} />
        <section className="pb-16 md:pb-24 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl tracking-tight font-medium mb-4" style={{fontFamily:"Outfit, sans-serif"}}>Send an enquiry</h2>
          <EnquiryForm testIdPrefix="contact" messagePlaceholder="How can we help?" />
        </section>
      </div>
    </>
  );
}
